import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import {mutations} from "./mutations.js";
import {actions} from "./actions.js";

//创建一个vuex的store对象
export default new Vuex.Store({
    //全局共享状态
    state: {
        // 登录用户名
        userName :"",
        //是否有提示框
        tipshow : false,
        // 是否登录
        isLogin : false,
        // 模糊查询下拉框是否显示
        showlist: false,
        // // 阻止模糊查询
        // preventMohu:true,
        // 模糊查询的数据
        item : [],
        // 模糊信号量
        mohuIndex: 0,
        alreadyClick : false,
        // 当前的路由的类型
        routeType :'',
        //面板详情和鼠标移上事件的切换
        change_tab : false ,
        // 详情面板的开合状态
        nl_Status:true,
        // 第一次合并线之后的id字典序列
        jsonSort_node:{},
        jsonSort_link:{},
        // 最初的并且线是合并完成之后的result，包括nodes和links
        netResult:null,
        // 输入的中心节点
        initialNodes:[],
        // 风险视图的主体企业的zsid
        innode_zsid:'',
        //风险视图的 queryAttrId
        queryAttrId:null,
        queryName:'',
        queryModel:'',
        loadding:false,
        doubleMap:[],//风险系数双击存储
        innode_icon_company:false,
        innode_icon_people:false,
        isInvididual:false,
        mainList:true
    },
    getters : {

    },
    mutations,
    actions
});


// WEBPACK FOOTER //
// ./src/store/index.js